export default "__VITE_ASSET__BIOgypb9__"